import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useRejection} from "../../context/RejectionContext";
import DefaultLayout from "../../components/Layout/DefaultLayout";
import {Link, Outlet, useSearchParams} from "react-router-dom";
import {useAuth} from "../../context/AuthContext";
import SuccessAlert from "../../components/Layout/SuccessAlert";
import ListBottomPager from "../../components/ListBottomPager";
import {useCustomers} from "../../hooks/api/customer";
import {Controller, useForm} from "react-hook-form";
import Select from "react-select";
import DatePicker from "react-date-picker";


const ListRejection = () => {
    const { t } = useTranslation();
    const [successMessage, setSuccessMessage] = useState(null)
    const [customersOptions, setCustomersOptions] = useState([])
    const [statusOptions, setStatusOptions] = useState([])
    const [listParams, setListParams] = useState(null)
    const {rejections, metaData, fetchAll} = useRejection()
    const [{customers}, {fetchAll: fetchAllCustomer}] = useCustomers()
    const {hasRight} = useAuth()
    const [searchParams, setSearchParams] = useSearchParams();

    const {
        formState: { errors: formErrors },
        control,
        setValue,
        reset
    } = useForm({})

    useEffect(() => {
        fetchAllCustomer()
        const date = searchParams.get('date');
        const customerId = searchParams.get('customerId');
        const status = searchParams.get('status');
        const motif = searchParams.get('motif');
        const page = searchParams.get('page');

        if (date) {
            setValue('date', date)
        }
        if (customerId) {
            setValue('customerId', parseInt(customerId))
        }
        if (status) {
            setValue('status', status)
        }
        if (motif) {
            setValue('motif', motif)
        }
        if (page) {
            setValue('page', page)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (customers) {
            const options = customers.map((customer => {
                return { label: customer.name, value: customer.id }
            }))
            setCustomersOptions(options)
        }
    }, [customers])

    useEffect(() => {
        if (metaData) {
            const options = Object.keys(metaData.countByStatus).map(key => {
                return { label: `${t(`rejection.status.${key}`)} - ${metaData.countByStatus[key]}`, value: key, className: `select-option-${key}` }
            })

            setStatusOptions(options)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [metaData])

    const handleSelect = (event) => {
        const {name, value} = event?.target;
        setSearchParams(searchParams => {
            if (value === undefined) {
                searchParams.delete(name)
            } else {
                searchParams.set(name, value);
            }
            searchParams.set('page', '1');

            return searchParams;
        });
    }

    const handleDate = (event) => {
        const {name, value} = event?.target;
        setSearchParams(searchParams => {
            if (value === undefined || value === null) {
                searchParams.delete(name)
            } else {
                const stringDate = value.toLocaleDateString("fr").replaceAll('/', '-')
                searchParams.set(name, stringDate);
            }
            searchParams.set('page', '1');

            return searchParams;
        });
    }

    const handlePage = (page) => {
        setSearchParams(searchParams => {
            if (page === undefined || page === null) {
                searchParams.delete('page')
            } else {
                searchParams.set('page', page);
            }

            return searchParams;
        });
    }

    useEffect(() => {
        const customerId = searchParams.get('customerId');
        const date = searchParams.get('date');
        const status = searchParams.get('status');
        const page = searchParams.get('page');
        const motif = searchParams.get('motif');

        const params = []
        if (customerId) {
            params['customerId'] = customerId
        } else {
            reset({customerId: null})
        }

        if (date) {
            params['date'] = date
        }
        if (status) {
            params['status'] = status
        }
        if (page) {
            params['page'] = page
        }
        if (motif) {
            params['motif'] = motif
        }

        if (Object.keys(params).length > 0) {
            const listParamsString = Object.keys(params).map((key) => {
                return (`${key}=${params[key]}`)
            }).join('&')

            setListParams(listParamsString)
        } else {
            setListParams(null)
        }

        fetchAll(params)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchParams]);

    console.log(rejections)

    return (
        <DefaultLayout>
            {hasRight('rejection_import') && <Link
                to={'/rejection/import'}
                className="btn btn-primary float-end mt-n1 ms-2"
            >
                <i className="fa-solid fa-file-excel" style={{marginRight: '10px'}}></i>
                {t('rejection.list.button.import')}
            </Link>}
            {hasRight('rejection_new') && <Link
                to={'/rejection/new'}
                className="btn btn-primary float-end mt-n1"
            >
                <i className="fas fa-plus" style={{marginRight: '10px'}}></i>
                {t('rejection.list.button.add')}
            </Link>}
            <h1 className="h3 mb-3">{t('rejection.list.title')}</h1>

            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-header">
                            <div className="row">
                                <div className="col-sm-12 col-md-3">
                                    <Controller
                                        name="customerId"
                                        control={control}
                                        render={({field}) => (
                                            <Select
                                                fieldName={field.name}
                                                placeholder={t('rejection.list.filters.customer.place-holder')}
                                                inputRef={field.ref}
                                                options={customersOptions}
                                                value={customersOptions.find((c) => c.value === field.value)}
                                                onChange={val => {
                                                    field.onChange(val?.value);
                                                    handleSelect({ target: { name: 'customerId', value: val?.value } });
                                                }}
                                                isInvalid={formErrors && formErrors.healthInsuranceId}
                                                className={`p-0 form-control form-control-lg ${formErrors && formErrors.customerId ? ' is-invalid' : ''}`}
                                                isClearable
                                            />)
                                        }
                                    />
                                </div>
                                <div className="col-sm-12 col-md-3">
                                    <Controller
                                        name="date"
                                        control={control}
                                        render={({field}) => (
                                            <DatePicker
                                                onChange={(val) => {
                                                    field.onChange(val);
                                                    handleDate({ target: { name: 'date', value: val } });
                                                }}
                                                value={field.value}
                                                className={`p-0 form-control form-control-lg ${formErrors && formErrors.invoiceDate ? ' is-invalid' : ''}`}
                                                format={"dd-MM-y"}
                                            />
                                        )}
                                    />
                                </div>
                                <div className="col-sm-12 col-md-3">
                                    <Controller
                                        name="status"
                                        control={control}
                                        render={({field}) => (
                                            <Select
                                                fieldName={field.name}
                                                placeholder={t('rejection.list.filters.status.place-holder')}
                                                inputRef={field.ref}
                                                options={statusOptions}
                                                value={statusOptions.find((c) => c.value === field.value)}
                                                onChange={val => {
                                                    field.onChange(val?.value);
                                                    handleSelect({ target: { name: 'status', value: val?.value } });
                                                }}
                                                isInvalid={formErrors && formErrors.status}
                                                className={`p-0 form-control form-control-lg ${formErrors && formErrors.status ? ' is-invalid' : ''}`}
                                                isClearable
                                            />)
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="dataTables_wrapper dt-bootstrap5 no-footer">
                                <div className="row">
                                    <div className="col-sm-12">
                                        {successMessage && <SuccessAlert message={successMessage}/>}

                                        <div className="table-responsive">
                                            <table className="table table-hover table-striped">
                                                <thead>
                                                <tr>
                                                    <th scope="col">{t('rejection.list.customer')}</th>
                                                    <th scope="col">{t('rejection.list.patientName')}</th>
                                                    <th scope="col">{t('rejection.list.invoiceDate')}</th>
                                                    <th scope="col">{t('rejection.list.motif')}</th>
                                                    <th scope="col">{t('rejection.list.invoiceNumber')}</th>
                                                    <th scope="col">{t('rejection.list.payingAgency')}</th>
                                                    <th scope="col">{t('rejection.list.remainingAmount')}</th>
                                                    <th scope="col">{t('rejection.list.status')}</th>
                                                    <th>Actions</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {rejections && rejections.map((rejection, key) => (
                                                    <tr
                                                        key={key}
                                                    >
                                                        <td>{rejection.customer?.name}</td>
                                                        <td>{rejection.patientName}</td>
                                                        <td>{rejection.invoiceDate}</td>
                                                        <td></td>
                                                        <td>{rejection.invoiceNumber}</td>
                                                        <td>{rejection.payingAgency?.name}</td>
                                                        <td>{rejection.remainingAmount}€</td>
                                                        <td>

                                                        </td>
                                                        <td>
                                                            {hasRight('tiers_payant_comment') && <Link
                                                                to={`/tiers-payant/comment/${rejection.id}${listParams ? `?${listParams}` : ''}`}
                                                            >
                                                                Gérer le dossier
                                                            </Link>}
                                                        </td>
                                                    </tr>
                                                ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <ListBottomPager metaData={metaData} handlePage={handlePage}/>
                            </div>
                        </div>
                    </div>
                </div>
                <Outlet
                    context={{setSuccessMessage}}
                />
            </div>
        </DefaultLayout>
    )
}

export default ListRejection